import _styled from '@emotion/styled/base';
import { css } from '@emotion/react';
import { IconAlertFilled, IconCheckCircleFilled } from '@hubble/icons';
import 'react';
import { shorthandSpacingCss } from './primitives/Spacer/index.js';
import { Text } from './Text/index.js';
import '@emotion/react/jsx-runtime';
import { Spacing } from './primitives/spacing.js';
import { Colors } from './primitives/color.js';

const FORM_ELEMENT_TEXT_STYLES = {
  display: 'flex',
  alignItems: 'center',
  fontSize: '16px',
  lineHeight: '24px',
  color: Colors.gray[800],
  whiteSpace: 'nowrap'
};
const formElementTextStyles = css(FORM_ELEMENT_TEXT_STYLES);
_styled("label", {
  target: "e1hw1i623"
})("min-height:112px;width:100%;", shorthandSpacingCss, ";");
_styled(IconAlertFilled, {
  target: "e1hw1i622"
})("margin-top:1px;margin-right:", Spacing.scale[0.5], ";align-self:flex-start;flex:none;");
_styled(IconCheckCircleFilled, {
  target: "e1hw1i621"
})("width:", Spacing.scale[2.5], ";height:", Spacing.scale[2.5], ";position:absolute;top:", Spacing.scale[2.5], ";left:-", Spacing.scale[4], ";");
_styled(Text.Body, {
  target: "e1hw1i620"
})({
  name: "s5xdrg",
  styles: "display:flex;align-items:center"
} );

export { FORM_ELEMENT_TEXT_STYLES, formElementTextStyles };
